import React from 'react';
import '@builder.io/widgets';
import { builder, BuilderComponent } from '@builder.io/react';
import { BUILDER_API_KEY } from '../../utils/environment';
import { pickBy } from 'lodash';
import { SHOP_LOCALE } from 'src/scripts/utils/constants';
import { pathWithoutLocale } from '../../utils/localization';
import { builderAddToCart } from 'src/scripts/utils/cart';

// Init builder
if (BUILDER_API_KEY && !builder.apiKey) builder.init(BUILDER_API_KEY);

const BuilderReactComponent = ({
  isLoggedIn,
  countryCode = '',
  model,
  contentEntryId,
  collectionHandle = '',
  productHandle = '',
  userAgent = '',
}: {
  isLoggedIn?: boolean;
  countryCode?: string;
  collectionHandle?: string;
  productHandle?: string;
  contentEntryId?: string;
  model: string;
  userAgent: string;
}) => {
  return (
    <BuilderComponent
      model={model}
      context={{
        addToCart: builderAddToCart,
      }}
      options={pickBy({
        entry: contentEntryId,
        locale: SHOP_LOCALE,
        userAttributes: !contentEntryId
          ? {
              urlPath: pathWithoutLocale(window.location.pathname),
              isLoggedIn,
              countryCode,
              collectionHandle,
              productHandle,
              userAgent,
            }
          : undefined,
      })}
    />
  );
};

export default BuilderReactComponent;
